
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexationProfileSecuritiesEditDialog extends Common.GridEditorDialog<IndexationProfileSecurityRow> {
        protected getFormKey() { return IndexationProfileSecurityForm.formKey; }
        protected getIdProperty() { return IndexationProfileSecurityRow.idProperty; }
        protected getLocalTextPrefix() { return IndexationProfileSecurityRow.localTextPrefix; }
        protected getDeletePermission() { return IndexationProfileSecurityRow.deletePermission; }
        protected getInsertPermission() { return IndexationProfileSecurityRow.insertPermission; }
        protected getUpdatePermission() { return IndexationProfileSecurityRow.updatePermission; }

        protected form = new IndexationProfileSecurityForm(this.idPrefix);

    }
}